import React from 'react'
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import Button from './Button';
import footerLogo from '../img/symb.svg'
import footerImg from '../img/footer-img.svg'

export default function Footer() {
  return (
    <footer className='container'>
      <section className='footer-main'>
        <header className='footer-title'>
          <h1>Have goals? Partner <span>With Us</span></h1>
          <img src={footerImg} alt='footerImg' />
        </header>
        <article className='contacts'>
          <h4>Our Contacts</h4>
          <div className='contact-address'>
            <p className='p2'>Address</p>
            <p className='p1'>2857 East Independence BLVD, Matthews, NC 28105</p>
          </div>
          <div className='contact-email'>
            <p className='p2'>Email</p>
            <p className='p1'>sales<span>@</span>buildthetech.com</p>
          </div>
          <div className='contact-apps'>
            <a href='#' className='contact-youtube'><FaYoutube /></a>
            <a href='#' className='contact-instagram'><FaInstagram /></a>
            <a href='#' className='contact-xtwitter'><FaXTwitter /></a>
            <a href='#' className='contact-linkedin'><FaLinkedin /></a>
          </div>
        </article>
        <Button cls='button-primary' />
      </section>
      <footer className='footer-bottom'>
        <div className='footer-brand'>
          <img src={footerLogo} alt='footer-logo'/>
          <p className='p1'>BuildTheTech LLC © Copyright 2025  - All Rights Reserved</p>
        </div>
        <nav>
          <a href='#' className='p2'>Therms & Conditions</a>
          <a href='#' className='p2'>Privacy Policy</a>
        </nav>
      </footer>
    </footer>
  )
}
